import Modal from "../Modal/Modal";
import { Container, MainButton } from "./VolanteReviewingDocModalStyles";

function VolanteReviewingDocModal(props) {
  const { toggleModal } = props;

  return (
    <Modal onOutsideClick={() => toggleModal()}>
      <Container>
        <h1>Documento en revisión</h1>
        <p>
          Este volante ya tiene un documento en revisión, puede ver el estado
          del volante en el apartado “Gestión de validaciones”.
        </p>
        <MainButton onClick={() => toggleModal(true)}>Entendido</MainButton>
      </Container>
    </Modal>
  );
}

export default VolanteReviewingDocModal;
